<template>
	<pp-modal on-visible-change="modelchange" v-model="showModal" :mask-closable="false" width="488">
		<p slot="header" class="modalHead">
			<span>{{modalheader}}</span>
		</p>
		<div class="modalContent">
			<p>{{modalcontent}} {{currency}} {{$filters.money(amount)}}</p>
			<div>
				<pp-row>
					<pp-col :span="12">
						<pp-form class="formstyle" ref="formCustom" :model="formCustom" :rules="rules">
							<pp-form-item prop="confirmAmount" class="control-input">
								<pp-input
									v-model.trim="formCustom.confirmAmount"
									:value="formCustom.confirmAmount"
									type="text"
									:placeholder="currency"
									@on-blur="onchange"
									class="inputstyle"
								></pp-input>
							</pp-form-item>
						</pp-form>
					</pp-col>
					<pp-col :span="12">
						<div class="all" @click="getAllAmount">{{$t('webList.webDetail.allFunds')}}</div>
					</pp-col>
				</pp-row>
				<p
					class="tip-text"
				>{{$t('webList.webDetail.withdrawalFee')}}（{{currency}}）：{{$filters.money(feeAmount)}}</p>
				<p
					class="tip-text"
				>{{$t('webList.webDetail.estimatedTransferredAmount')}}（{{currency}}）：{{$filters.money(withdrawAmount)}}</p>
			</div>
		</div>
		<div slot="footer">
			<!-- <el-divider></el-divider> -->
			<ul class="attention">
				<li>{{$t('webList.webDetail.attention')}}</li>
				<li>{{$t('webList.webDetail.attentionLine1')}}</li>
				<li style="padding:18px 0 18px;">{{$t('webList.webDetail.attentionLine2')}}</li>
			</ul>
			<pp-button
				type="primary"
				size="spec"
				:loading="loading2"
				:disabled="isDisabledWithdraw"
				@click="commit()"
			>{{$t('webList.webDetail.confirm')}}</pp-button>
		</div>
	</pp-modal>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const {
	mapGetters: webMapGetters,
	mapActions: webMapActions
} = createNamespacedHelpers("paymentRecord");
export default {
	name: "cancleModal",
	props: {
		modalcontent: "",
		modalheader: "",
		currency: "",
		tradeId: "",
		accId: "",
		clientId: "",
		orderId: "",
		params: "",
		feeAmount: "",
		amount: ""
	},
	computed: {
		...webMapGetters(["withdrawRes"]),
		isDisabledWithdraw() {
			return this.formCustom.confirmAmount > this.amount || false;
		}
	},
	data() {
		return {
			loading2: false,
			showModal: false,
			rules: {
				confirmAmount: [
					{
						required: true,
						trigger: "blur",
						validator: (rule, value, callback) => {
							this.formCustom.confirmAmount = this.$filters.pureMoney(
								this.formCustom.confirmAmount
							);
							// Number(this.formCustom.confirmAmount).toFixed(2)
						}
					}
				]
			},
			formCustom: {
				confirmAmount: ""
			},
			withdrawAmount: ""
		};
	},
	methods: {
		...webMapActions([
			"doWithdraw" // 获取交易详情
		]),
		onchange() {
			this.withdrawAmount =
				this.formCustom.confirmAmount - this.feeAmount;
		},
		getAllAmount() {
			this.formCustom.confirmAmount = this.$filters.pureMoney(
				this.amount
			); //Number(this.amount).toFixed(2)
			this.withdrawAmount =
				this.formCustom.confirmAmount - this.feeAmount;
		},
		show() {
			this.showModal = true;
			this.formCustom.confirmAmount = "";
			this.withdrawAmount = "";
		},
		cancle() {
			this.showModal = false;
			this.formCustom.confirmAmount = "";
			this.withdrawAmount = "";
		},
		commit() {
			let value = Number(this.formCustom.confirmAmount);
			let amount = Number(this.amount);
			if (value > amount) {
				this.$message.error(this.$t("webList.withdrawModal.formRules"));
				return false;
			} else {
				const amountReg = /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/;
				var reg = amountReg.test(value);
				if (reg) {
					this.confirmfun();
				} else {
					this.$message.error(
						this.$t("webList.withdrawModal.formRules2")
					);
					return false;
				}
			}
		},
		// 获取初始化交易记录数据
		async confirmfun() {
			let params = {
				accId: this.params.accId,
				clientId: this.params.clientId,
				currency: this.currency,
				amount: this.formCustom.confirmAmount
			};
			this.loading2 = true;
			await this.doWithdraw(params);
			this.loading2 = false;
			if (this.withdrawRes === "SUCCESS") {
				this.$message.success(this.$t("webList.withdrawModal.success"));
				this.showModal = false;
			}
			this.formCustom.confirmAmount = "";
			this.withdrawAmount = "";
			this.$emit("finish");
		}
	}
};
</script>

<style lang="scss" scoped>
.modalHead {
	color: #000;
	font-size: 20px;
	text-align: left;
}

.modalContent {
	text-align: left;
	font-size: 14px;
}

.control-input {
	margin: 20px 0 0px;
	width: 200px;

	span {
		display: block;
		float: left;
	}
}

.all {
	width: 200px;
	height: 76px;
	line-height: 76px;
	cursor: pointer;
	color: #1fa0e8;
}
.inputstyle {
	margin-bottom: 6px;
}
.tip-text {
	color: #7b7b7b;
	line-height: 1.5;
}
.attention {
	padding-top: 20px;
	text-align: left;
	font-size: 12px;
	line-height: 18px;
	border-top: 1px solid #f0f6fa;
}
::v-deep .pp-modal-footer {
	padding: 0 18px 30px;
}
</style>
